const zhouyiDetail = {
  'header.title': '周易占卜',
  'header.manage': '檔案管理',
  'banner.tag': '傳統術數',
  'banner.title': '周易占卜 · 傳統術數全解',
  'banner.subtitle': '融合六爻、梅花、奇門、相學等十大傳統占卜體系',
  'category.divination': '占卜推算',
  'category.physiognomy': '相學解讀',
  'tabs.portrait': '卦象畫像',
  'tabs.liuyao': '六爻',
  'tabs.meihua': '梅花易數',
  'tabs.qimen': '奇門遁甲',
  'tabs.daliuren': '大六壬',
  'tabs.taiyi': '太乙',
  'tabs.jinkojue': '金口訣',
  'tabs.mianxiang': '面相',
  'tabs.shouxiang': '手相',
  'tabs.guxiang': '骨相',
  'tabs.tixiang': '體相',
  'stats.traditions': '占卜體系',
  'stats.traditionsUnit': '種',
  'stats.history': '歷史',
  'stats.historyUnit': '年',
  'stats.accuracy': '準確率',
  'stats.users': '用戶',
  'stats.usersUnit': '萬',
  'stats.updates': '更新',
  'stats.updatesValue': '日更',

  // ── LiuyaoTab ─────────────────────────────────────────────────
  'liuyao.intro.title': '新手必讀：六爻是什麼？',
  'liuyao.intro.tag': '新手',
  'liuyao.intro.principle.title': '六爻納甲法的核心原理',
  'liuyao.intro.principle.desc': '六爻（納甲法）源自《周易》，透過擲銅板（或六枚）的方式得出六十四卦之一，再結合當日天干地支與五行生剋，預測事件的吉凶走向。',
  'liuyao.intro.yao.label': '爻（線）',
  'liuyao.intro.yao.desc': '卦的基本單位。「—」（陽爻）代表積極進取；「--」（陰爻）代表靜待時機。六爻組成一完整的卦象。',
  'liuyao.intro.shiying.label': '世爻與應爻',
  'liuyao.intro.shiying.desc': '世爻代表「自己」（問卦者），應爻代表「對方」或「事情結果」。兩者的生剋關係（相生/相剋）揭示你與事情的互動狀態。',
  'liuyao.intro.liuqin.label': '六親',
  'liuyao.intro.liuqin.desc': '以日干五行為基準，將六爻分為：妻財（財運/伴侶）、子孫（喜事/子女）、官鬼（職場壓力/官非）、兄弟（競爭/破財）、父母（文書/長輩）。',
  'liuyao.intro.liushen.label': '六神',
  'liuyao.intro.liushen.desc': '青龍主吉祥，朱雀主口舌，勾陳主遲滯，騰蛇主虛驚，白虎主危險，玄武主暗昧。六神附於各爻，加強爻的吉凶力量。',
  'liuyao.intro.dongyao.label': '動爻',
  'liuyao.intro.dongyao.desc': '老陽（九）與老陰（六）稱為動爻，代表當前變化的關鍵所在。動爻所代表的六親是近期最重要的關注焦點。',
  // ── 六爻結果結論 ───────────────────────────────────────
  'liuyao.conclusion.title': '卦象總論',
  'liuyao.conclusion.summaryLabel': '一句話總評',
  'liuyao.conclusion.upperLabel': '上卦',
  'liuyao.conclusion.lowerLabel': '下卦',
  'liuyao.conclusion.relationLabel': '五行關係',
  'liuyao.conclusion.dayGanLabel': '日干',
  'liuyao.movingYao.title': '動爻爻辭詳解',
  'liuyao.movingYao.multiHint': '此卦有{{count}}爻動，變化多端，需綜合各爻六親含義進行判斷',
  'liuyao.wuxingFlow.title': '五行流通分析',
  'liuyao.wuxingFlow.shengLabel': '相生',
  'liuyao.wuxingFlow.shengDesc': '木生火、火生土、土生金、金生水、水生木',
  'liuyao.wuxingFlow.keLabel': '相剋',
  'liuyao.wuxingFlow.keDesc': '木剋土、土剋水、水剋火、火剋金、金剋木',
  'liuyao.wuxingFlow.monthLabel': '月令（{{month}}月）',
  'liuyao.wuxingFlow.monthHint': '月令屬{{monthWX}}，此時{{monthWX}}當令，屬{{monthWX}}的爻最旺',
  'liuyao.liuqin.title': '六親六神・逐爻詳解',
  'liuyao.liuqin.expand': '點擊展開',
  'liuyao.liuqin.header.title': '如何解讀六親六神？',
  'liuyao.liuqin.header.desc': '六親由日干五行生剋決定；六神從初爻起依次排列。世爻所代表的六親就是你當下的狀態。動爻意味著變化——旺相表示力量強，休囚死表示力量弱。',
  'liuyao.liushenDesc.qinglong': '青龍主吉祥——貴人出現，事情順利愉快地推進。',
  'liuyao.liushenDesc.zhuque': '朱雀主口舌與文書——言語要謹慎，合同要細審。',
  'liuyao.liushenDesc.gouxian': '勾陳主延誤——事情推進緩慢，需耐心等待，切勿急躁。',
  'liuyao.liushenDesc.tengshe': '騰蛇主虛驚——可能有意外擔憂，但實際影響比預想的小。',
  'liuyao.liushenDesc.baihu': '白虎主危險與衝突——謹慎處理相關事務，避免正面交鋒。',
  'liuyao.liushenDesc.xuanwu': '玄武主暗昧——相關事務可能缺乏透明度，謹慎行事。',
  'liuyao.liuqinDesc.guanGui': '代表職場壓力與管理約束。若旺而動，防官司糾紛，以柔化解。',
  'liuyao.liuqinDesc.qiCai': '代表財運與感情伴侶。若持世爻，財運感情俱佳——把握機遇。',
  'liuyao.liuqinDesc.ziSun': '代表喜事與子女。若近世爻，凡事以平常心應對，逢凶化吉。',
  'liuyao.liuqinDesc.xiongDi': '代表競爭與破財。若頻頻動搖，防財物損失——以和為貴。',
  'liuyao.liuqinDesc.fuMu': '代表文書與長輩。若在位，利考試合約，亦有長輩扶持。',
  'liuyao.detail.viewBtn': '查看詳細解析',
  'liuyao.score.title': '綜合斷語',
  'liuyao.score.overall': '總運',
  'liuyao.score.career': '事業',
  'liuyao.score.wealth': '財運',
  'liuyao.score.love': '感情',
  'liuyao.score.health': '健康',
  'liuyao.jiehua.label': '優化參考',
  'liuyao.detail.title': '五維詳細解析',
  'liuyao.shiying.title': '世應關係分析',
  'liuyao.shiying.principle.title': '世應的意義',
  'liuyao.shiying.principle.desc': '世爻是「我」，應爻是「對方/結果」。看兩者五行關係：世剋應→我掌主動；應剋世→外部壓力大，宜守；世應相生→互利；同氣→立場一致。',
  'liuyao.shiying.shi': '世爻（自身）',
  'liuyao.shiying.ying': '應爻（對方）',
  'liuyao.shiying.advice': '綜合建議',
  'liuyao.shiying.moving': '有動爻，表示這些爻所代表的事務正處於變化期——需密切關注。',
  'liuyao.shiying.still': '目前卦中無動爻，整體局勢相對穩定——維持現狀為宜。',
  'liuyao.judgment.overall.high': '今日卦象大吉，陽氣充盈，諸事順暢，貴人相助——積極推進。',
  'liuyao.judgment.overall.mid': '今日卦象平穩，進退皆宜，步步為營，不宜冒進。',
  'liuyao.judgment.overall.low': '今日卦象有阻，守強攻弱，靜待時機，調整方向化解困局。',
  'liuyao.judgment.love.high': '感情卦象大吉，子孫持世，情意融洽，緣分順暢——主動表達情意。',
  'liuyao.judgment.love.mid': '感情穩步推進，真誠投入，坦誠相待，感情自然升溫。',
  'liuyao.judgment.love.low': '感情有些挫折，放慢腳步，多溝通，不宜急於求成，自然化解。',
  'liuyao.judgment.career.high': '事業星高照，貴人扶持，升遷有望——積極爭取機會。',
  'liuyao.judgment.career.mid': '事業穩步推進，父母爻旺——利進修積累。',
  'liuyao.judgment.career.low': '事業暫時受阻，守住現有位置，待機而動——機會自來。',
  'liuyao.judgment.wealth.high': '妻財爻旺，財源可期——利開拓新的進財渠道。',
  'liuyao.judgment.wealth.mid': '財運平穩，量入為出，穩步積累，勿冒進。',
  'liuyao.judgment.wealth.low': '財運暫弱，謹慎用錢，避免大額投資——守財為上。',
  'liuyao.judgment.health.high': '子孫爻持世，身心舒泰——精力充沛，身體健康。',
  'liuyao.judgment.health.mid': '健康整體平穩，保持規律作息與良好心態。',
  'liuyao.judgment.health.low': '略感疲乏，靜養休息，減少不必要的過度消耗。',
  'liuyao.jiehuaWay.0': '卦意靜守勝於動進——平心靜氣，以柔克剛，靜待時機。',
  'liuyao.jiehuaWay.1': '動爻化空——延緩決策，等待事情自然定案。',
  'liuyao.jiehuaWay.2': '官鬼在爻——強化正向行動，保持清醒，避免無謂口舌。',
  'liuyao.jiehuaWay.3': '雖爻有阻，五行流通——靈活應變，可化解困局。',
  'liuyao.jiehuaWay.4': '變卦現吉兆——事情正在好轉，走正道順勢而行。',

  // ── 六親六神總覽 & 動爻核心 & 伏神 ─────────────────────────────
  'liuyao.core.title': '六親 · 六神 · 世應總覽',
  'liuyao.core.tag': '核心',
  'liuyao.core.colPos': '爻位',
  'liuyao.core.colYao': '爻象',
  'liuyao.core.colShen': '六神',
  'liuyao.core.colQin': '六親',
  'liuyao.core.colNaJia': '納甲',
  'liuyao.core.colWang': '旺衰',
  'liuyao.core.colTag': '標記',
  'liuyao.core.shiLabel': '世爻（我）',
  'liuyao.core.yingLabel': '應爻（對方）',
  'liuyao.moving.title': '動爻核心分析',
  'liuyao.moving.benGua': '本卦',
  'liuyao.moving.bianGua': '變卦',
  'liuyao.moving.arrow': '→ 動爻變化 →',
  'liuyao.moving.huaJinTui': '化進退分析',
  'liuyao.moving.huiTou': '回頭生剋分析',
  'liuyao.moving.yaoCi': '動爻爻辭',
  'liuyao.fushen.title': '伏神分析',
  'liuyao.fushen.tag': '六親不全時啟用',
  'liuyao.fushen.desc': '卦中六親不全，缺失的六親以「伏神」形式潛藏於卦中。占問相關事宜時，需察伏神所在爻位，判斷其旺衰動靜。',
  'liuyao.fushen.fuYu': '{{qin}} 伏於 {{pos}}',
  'liuyao.filter.all': '全部',

  // ── LiuyaoTab 數據翻譯 keys ──────────────────────────────────
  'liuyao.linePos.chu': '初爻',
  'liuyao.linePos.er': '二爻',
  'liuyao.linePos.san': '三爻',
  'liuyao.linePos.si': '四爻',
  'liuyao.linePos.wu': '五爻',
  'liuyao.linePos.shang': '上爻',
  'liuyao.liuShen.qinglong': '青龍',
  'liuyao.liuShen.zhuque': '朱雀',
  'liuyao.liuShen.gouchen': '勾陳',
  'liuyao.liuShen.tengshe': '螣蛇',
  'liuyao.liuShen.baihu': '白虎',
  'liuyao.liuShen.xuanwu': '玄武',
  'liuyao.liuQin.guanGui': '官鬼',
  'liuyao.liuQin.qiCai': '妻財',
  'liuyao.liuQin.ziSun': '子孫',
  'liuyao.liuQin.xiongDi': '兄弟',
  'liuyao.liuQin.fuMu': '父母',
  'liuyao.wangXiang.旺': '旺',
  'liuyao.wangXiang.相': '相',
  'liuyao.wangXiang.休': '休',
  'liuyao.wangXiang.囚': '囚',
  'liuyao.wangXiang.死': '死',
  'liuyao.shiBadge': '世',
  'liuyao.yingBadge': '應',
  'liuyao.movingBadge': '動',
  'liuyao.dayGanLabel': '日干',
  'liuyao.movingYaoLabel': '動爻',
  'liuyao.noMovingYaoText': '無動爻',
  'liuyao.changedHexLabel': '變卦',
  'liuyao.shiYaoCardLabel': '世',
  'liuyao.shiYaoInfoTemplate': '世爻在{{pos}}，六親為{{qin}}，納甲{{zhi}}，現為{{wang}}',
  'liuyao.yingYaoInfoTemplate': '應爻在{{pos}}，六親為{{qin}}，納甲{{zhi}}',
  'liuyao.wuxing.木': '木',
  'liuyao.wuxing.火': '火',
  'liuyao.wuxing.土': '土',
  'liuyao.wuxing.金': '金',
  'liuyao.wuxing.水': '水',

  // ── 白話解釋 ─────────────────────────────────────────────────
  'liuyao.baihua.btn': '白話解釋報告詳情',
  'liuyao.baihua.boundary.title': '命理學解讀能力邊界',
  'liuyao.baihua.boundary.desc': '六爻預測源於《周易》，通過三枚銅錢六次搖卦，把您心中的問題「翻譯」成一套天地符號系統。它能幫助您看清事情的來龍去脈、有利和不利因素，讓您在關鍵時刻做出更明智的決策。然而，六爻並非宿命論，它提供的是一種可能性和傾向性，具體的結果仍需結合您的個人努力、選擇和外部環境。本報告將基於您的卦象，為您提供清晰、務實的分析和建議，助您更好地把握當下。',
  'liuyao.baihua.btnTitle': '白話解釋報告詳情',
  'liuyao.baihua.recommend': '推薦',
  'liuyao.baihua.close': '關閉',
  'liuyao.baihua.intro': '下面這份報告，是用您聽得懂的大白話，把上面的專業卦象翻譯了一遍。每個板塊都對應真實卦象數據，您放心看。',

  'liuyao.baihua.whatIs.title': '【六爻是什麼】',
  'liuyao.baihua.whatIs.desc': '六爻，是用三枚銅錢搖卦，把您心中的問題「翻譯」成一套天地符號系統的方法。它不會替您做決定，而是幫您看清事情的來龍去脈、有利和不利因素，讓您心裡更有底。',

  'liuyao.baihua.hex.title': '【本次卦象】',
  'liuyao.baihua.hex.moving': '這次您搖出的是「{{hexName}}」卦。卦中有動爻，變卦為「{{changedHexName}}」，說明這件事正處於變化之中，結果還沒有完全定型，您的態度和行動會對走向產生影響。下面我們把這個卦象拆開來，用大白話一條條講給您聽。',
  'liuyao.baihua.hex.still': '這次您搖出的是「{{hexName}}」卦。卦中六爻皆靜，沒有動爻，說明當前局面相對穩定，短期內不會有大的變動，趨勢比較明朗。下面我們把這個卦象拆開來，用大白話一條條講給您聽。',

  'liuyao.baihua.shi.title': '【世爻 · 您自己的狀態】',
  'liuyao.baihua.shi.intro': '世爻好比這齣戲的主角——就是您自己。這次世爻落在{{pos}}，五行屬{{wx}}，六親是「{{qin}}」。',
  'liuyao.baihua.shi.qin.brother': '您在這段關係或這件事裡，比較看重同輩、朋友、競爭者的角色。您有股不服輸的勁頭，遇到問題習慣自己扛，但也容易因為意氣用事而多花冤枉錢，或者與人產生摩擦。',
  'liuyao.baihua.shi.qin.qiCai': '這件事跟錢財、資源、感情對象密切相關。您本人的關注點很可能在「能不能得利」上，求財、求感情，心思比較務實。',
  'liuyao.baihua.shi.qin.guanGui': '這件事讓您有壓力，也可能是您心裡有個「坎」沒過去。官鬼代表憂慮、阻力、小人，也代表事業和地位。您現在的心態偏緊張，要提防過度焦慮影響判斷。',
  'liuyao.baihua.shi.qin.ziSun': '您的心態比較輕鬆，甚至有「順其自然」的傾向。子孫是福神，說明您有化解麻煩的潛質，但也可能過於樂觀，對風險預估不足。',
  'liuyao.baihua.shi.qin.fuMu': '您在這段關係或這件事裡，比較依賴長輩、文書、合約、學業這些因素。您重視規矩和安全感，但也容易想太多，給自己增加不必要的包袱。',
  'liuyao.baihua.shi.wang.旺': '勢頭正旺，狀態在線，這段時間您的氣場強，辦事有底氣。',
  'liuyao.baihua.shi.wang.相': '狀態不錯，有人幫忙、有資源支撐，雖然沒到巔峰，但夠用了。',
  'liuyao.baihua.shi.wang.休': '有點打不起精神，不是您不行，是時機還沒到，或者您自己還沒完全進入狀態。',
  'liuyao.baihua.shi.wang.囚': '被環境卡住了，有勁使不出，需要等待時機或者換個思路突圍。',
  'liuyao.baihua.shi.wang.死': '狀態低迷，這件事目前對您不利，強行推進容易碰壁，建議先穩住，觀望一下。',
  'liuyao.baihua.shi.summary.good': '總結一句話：您現在整體狀態在線，可以主動出擊。',
  'liuyao.baihua.shi.summary.normal': '總結一句話：您現在狀態一般，建議穩中求進，不要冒進。',

  'liuyao.baihua.ying.title': '【應爻 · 對方或客觀環境】',
  'liuyao.baihua.ying.intro': '應爻代表您問的事的「另一邊」——可能是合作方、競爭對手、上級領導，或者這件事的客觀環境。應爻落在{{pos}}，六親是「{{qin}}」，旺衰「{{wang}}」。',
  'liuyao.baihua.ying.qin.brother': '對方或環境對您有競爭意味，可能有人跟您搶資源、搶機會，或者對方態度強硬，不太容易讓步。',
  'liuyao.baihua.ying.qin.qiCai': '對方手裡有資源、有利益可圖，這件事本身有「利」的成分，但也說明對方比較現實，感情用事行不通。',
  'liuyao.baihua.ying.qin.guanGui': '這件事或對方給您帶來壓力和不確定性。可能是上級、規章制度、競爭對手，或者這件事本身就不好辦，需要費一番周折。',
  'liuyao.baihua.ying.qin.ziSun': '對方態度相對隨和，甚至有化解矛盾的空間。如果對方是合作方，說明合作阻力不大，可以試著推進。',
  'liuyao.baihua.ying.qin.fuMu': '對方比較看重規矩、合約、手續、長輩意見這些因素。想辦成事，先把「文書」和「流程」走順。',
  'liuyao.baihua.ying.state.good': '對方目前的狀態比較強勢，您需要更有策略地應對。',
  'liuyao.baihua.ying.state.normal': '對方目前的狀態也不算太強，您有機會爭取主動。',

  'liuyao.baihua.relation.title': '【世應關係 · 您和對方的互動】',
  'liuyao.baihua.relation.intro': '世爻是您，應爻是對方/環境，兩者之間的五行關係決定了這場互動的基調。',
  'liuyao.baihua.relation.detail': '從五行上看，世爻屬{{shiWx}}，應爻所在的納甲五行屬{{yingWx}}，兩者的關係是「{{relation}}」。',
  'liuyao.baihua.relation.detailNoWx': '從五行上看，世爻屬{{shiWx}}，應爻所在的納甲五行暫未標定，兩者的關係是「{{relation}}」。',
  'liuyao.baihua.relation.shiShengYing': '您在這段關係裡付出更多，有點「熱臉貼冷屁股」的味道。不是說不該付出，而是要注意別把自己耗空了，感情和事業都一樣，單向付出走不遠。',
  'liuyao.baihua.relation.yingShengShi': '對方對您有幫助、有扶持，這件事對您是有利的，可以順著這個勢走，別太抗拒。',
  'liuyao.baihua.relation.shiKeYing': '您手裡有主動權，對方被您壓著，這對您有利。但要注意分寸，逼太緊容易反彈，留點餘地更好。',
  'liuyao.baihua.relation.yingKeShi': '對方或環境對您有壓制，您現在處於下風。硬碰硬不划算，建議迂迴處理，或者先避其鋒芒，等對方氣勢弱了再找機會。',
  'liuyao.baihua.relation.biHe': '雙方勢均力敵，誰也不吃誰。合作的話需要明確分工，競爭的話靠真本事，沒有明顯的「貴人」也沒有明顯的「小人」。',
  'liuyao.baihua.relation.pingHe': '世應之間五行關係比較中性，事情的發展更多取決於您自己的努力和選擇，命理上並沒有特別明顯的偏向。',

  'liuyao.baihua.moving.title': '【動爻 · 事情的轉折點】',
  'liuyao.baihua.moving.many': '動爻是卦象的「發動機」，代表變化正在發生。這次共有 {{count}} 個動爻，說明這件事的變數比較多，局面複雜，建議您分階段推進，不要一把梭哈。',
  'liuyao.baihua.moving.two': '動爻是卦象的「發動機」，代表變化正在發生。這次共有 2 個動爻，說明這件事的變數集中在兩個關鍵點上，可能是兩個人、兩件事，或者兩個階段。',
  'liuyao.baihua.moving.one': '動爻是卦象的「發動機」，代表變化正在發生。這次共有 1 個動爻，說明這件事的變數集中在一點上，問題的突破口比較明確。',
  'liuyao.baihua.moving.none': '這次卦中沒有動爻，說明當前局面是「靜」的，短期內不會有大的變化。您問的事，現在的狀態就是真實狀態，不用猜來猜去。如果您的目的是改變現狀，那您自己得是那個「動爻」——主動採取行動，局面才會變。',
  'liuyao.baihua.moving.lineStrong': '這爻有力，說明這個方向的變化是「動真格的」，不是虛晃一槍，您要當真。',
  'liuyao.baihua.moving.lineWeak': '這爻力量不足，說明這個變化雖然出現了，但推動力有限，可能雷聲大雨點小，或者需要您推一把才能真正落地。',

  'liuyao.baihua.huaJinTui.title': '【化進退 · 趨勢是往好走還是往壞走】',
  'liuyao.baihua.huaJinTui.化進': '勢頭往上走，事情在往好的方向發展，可以期待。',
  'liuyao.baihua.huaJinTui.化退': '勢頭往下走，事情可能在消退、冷卻，您要抓緊，別等機會跑了。',
  'liuyao.baihua.huaJinTui.化伏': '這件事目前還在「潛伏」狀態，表面上沒動靜，但暗流湧動，需要耐心觀察。',
  'liuyao.baihua.huaJinTui.化变': '事情正在發生質變，舊的格局在打破，新的格局還沒形成，這個階段最考驗人的定力。',

  'liuyao.baihua.huiTou.title': '【回頭生剋 · 變卦對您是幫還是拆台】',
  'liuyao.baihua.huiTou.回頭生': '變出來的爻反過來生助您，這是好事，說明事情最後可能柳暗花明，有貴人暗中幫忙。',
  'liuyao.baihua.huiTou.回頭克': '變出來的爻反過來剋您，這是需要警惕的信號，可能好事多磨，或者最後關頭出岔子，建議您多留一手準備。',
  'liuyao.baihua.huiTou.泄氣': '您的力量被分散了，有點「吃力不討好」的感覺，做了不少但收效不大，建議調整策略，別硬撐。',
  'liuyao.baihua.huiTou.去克': '您有主動出擊的空間，可以去爭取、去推動，主動比被動好。',
  'liuyao.baihua.huiTou.比和': '變卦跟您平起平坐，變化不大，維持現狀的可能性比較高。',

  'liuyao.baihua.fuShen.title': '【伏神 · 藏在暗處的因素】',
  'liuyao.baihua.fuShen.intro': '伏神代表這件事裡「應該有但表面看不到」的力量，比如您心裡惦記但還沒說出口的想法，或者這件事背後真正起作用的隱性因素。',
  'liuyao.baihua.fuShen.reasonDefault': '這件事裡有一些您還沒看清的因素，它們雖然不顯眼，但可能在關鍵時刻起作用。',
  'liuyao.baihua.fuShen.reminder': '提醒：伏神就像冰山藏在水下的部分，您現在看到的只是水面上的。建議您多了解背景資訊，別光盯著表面現象。',

  'liuyao.baihua.shen.title': '【六神 · 這件事的氣場氛圍】',
  'liuyao.baihua.shen.intro': '六神不直接決定吉凶，它描述的是這件事的「氛圍」——好比天氣預報不決定您穿什麼，但告訴您今天冷不冷。',
  'liuyao.baihua.shen.qinglong': '青龍主喜慶、和順，這件事整體氛圍偏正面，可能有意外之喜，或者事情比您想像的順利。',
  'liuyao.baihua.shen.zhuque': '朱雀主口舌、資訊、溝通。這件事可能伴隨著很多討論、爭論、文書往來，要注意說話的分寸，避免言多必失。',
  'liuyao.baihua.shen.gouxian': '勾陳主拖延、阻滯、舊賬。這件事可能進展比較慢，或者有歷史遺留問題需要解決，急不得。',
  'liuyao.baihua.shen.tengshe': '騰蛇主虛驚、詭異、糾結。這件事可能讓您心裡七上八下，或者有一些您看不透、說不清的彎彎道道，建議您多留一個心眼。',
  'liuyao.baihua.shen.baihu': '白虎主凶險、壓力、傷害。這件事有一定風險，可能競爭激烈，或者對身體、情緒有消耗，建議您量力而行，別硬拼。',
  'liuyao.baihua.shen.xuanwu': '玄武主曖昧、隱秘、不確定。這件事有一些您還沒掌握的資訊，或者對方有所保留，建議您多做功課，別憑感覺下結論。',

  'liuyao.baihua.wuxing.title': '【上下卦關係 · 整體格局】',
  'liuyao.baihua.wuxing.biHe': '上下卦五行相同，說明這件事的內外因素比較一致，您心裡想的和外界表現出來的，沒有大的矛盾，但這也意味著缺少「外援」，全靠您自己。',
  'liuyao.baihua.wuxing.sheng': '上下卦相生，說明這件事有「互相成就」的空間，內外因素可以配合，您主動出擊容易得到回應。',
  'liuyao.baihua.wuxing.ke': '上下卦相剋，說明內外因素有矛盾，您心裡想的和實際情況可能有衝突，或者這件事本身就充滿張力，需要您在矛盾中找到平衡點。',
  'liuyao.baihua.wuxing.neutral': '上下卦關係比較中性，這件事的發展更多取決於具體行動，而不是大勢所趨。',

  'liuyao.baihua.score.title': '【各維度打分 · 這件事的「體檢報告」】',
  'liuyao.baihua.score.level.high': '相當不錯',
  'liuyao.baihua.score.level.mid': '中等偏上，有提升空間',
  'liuyao.baihua.score.level.low': '需要重點關注，建議謹慎',

  'liuyao.baihua.summary.title': '【綜合建議 · 給您的大白話總結】',
  'liuyao.baihua.summary.overall.good': '1. 這件事的整體得分{{score}}分，整體趨勢向好，您可以積極行動，但別得意忘形，好卦也需要努力配合。',
  'liuyao.baihua.summary.overall.mid': '1. 這件事的整體得分{{score}}分，有戲，但需要您更用心經營，不能光靠運氣。',
  'liuyao.baihua.summary.overall.low': '1. 這件事的整體得分{{score}}分，目前看來阻力不小，建議您先穩住陣腳，別急著下重注，多觀察、多準備，等時機好轉再發力。',
  'liuyao.baihua.summary.jiehua': '2. 調和參考：{{jiehuaWay}}',
  'liuyao.baihua.summary.jiehuaDefault': '2. 卦象顯示，您當下的行動和心態對結果影響最大。命理不是宿命，它更像一張「路況圖」，告訴您前面是直路還是彎道，但最終方向盤在您手裡。',
  'liuyao.baihua.summary.final': '3. 最後想跟您說一句：六爻不是算命，它是幫您理清思路的工具。卦象告訴您「現在是什麼情況」，但「接下來怎麼走」，永遠是您自己決定的。祝好。',

  // ── MeihuaTab ─────────────────────────────────────────────────
  'meihua.intro.title': '新手必讀：梅花易數是什麼？',
  'meihua.intro.origin.title': '梅花易數的誕生',
  'meihua.intro.origin.desc': '由宋代邵雍（邵康節）所創。傳說他曾觀梅花，見麻雀相爭墜落，即時起卦準確預言，故名「梅花易數」。',
  'meihua.intro.qugua.label': '以時取卦',
  'meihua.intro.qugua.desc': '以（年+月+日）÷8餘數為上卦，（年+月+日+時）÷8餘數為下卦，（年+月+日+時）÷6餘數為動爻。簡潔純粹。',
  'meihua.intro.sangua.label': '本卦・互卦・變卦',
  'meihua.intro.sangua.desc': '本卦為現狀，互卦（2-4爻為下，3-5爻為上）顯示隱藏本質，變卦（動爻翻轉）揭示最終方向。三卦合看方得全貌。',
  'meihua.intro.tiyong.label': '體用分析',
  'meihua.intro.tiyong.desc': '體卦代表「自己/主體」，用卦代表「對方/客體」。用生體吉，用剋體凶，體生用耗能，體剋用主動有利。這是梅花易數的核心斷卦法則。',
  'meihua.intro.wuxing.label': '五行象徵',
  'meihua.intro.wuxing.desc': '各卦均有五行：乾/兌=金，坎=水，震/巽=木，離=火，坤/艮=土。五行生剋直接決定運勢走向，並可預測事情發生的時間。',
  'meihua.tiyong.title': '體用分析詳解',
  'meihua.tiyong.header.title': '體用法說明',
  'meihua.tiyong.header.desc': '動爻在下卦（1-3爻）→上卦為體（代表你）；動爻在上卦（4-6爻）→下卦為體。',
  'meihua.tiyong.ti': '體卦（你）',
  'meihua.tiyong.yong': '用卦（事情）',
  'meihua.tiyong.element': '五行',
  'meihua.tiyong.relation': '關係',
  'meihua.tiyong.jiehua': '優化參考',
  'meihua.relation.same.result': '事情進展順暢，雙方合力，所求可持之以恆達成。',
  'meihua.relation.same.jiehua': '同氣相輔相成，順勢而為，把握當前機遇。',
  'meihua.relation.yongShengTi.result': '事情有外力扶持，貴人出現——事業與感情均呈正向發展。',
  'meihua.relation.yongShengTi.jiehua': '善用外部支持，主動出擊——時機已成熟。',
  'meihua.relation.tiShengYong.result': '需要主動付出，事情需要投入精力，但回報值得。',
  'meihua.relation.tiShengYong.jiehua': '量力而行，先謀後動，循序漸進——避免過度消耗。',
  'meihua.relation.yongKeTi.result': '當前阻力明顯，進取困難——暫停觀望，調整方向。',
  'meihua.relation.yongKeTi.jiehua': '勿強行突破——換個角度或尋求外援，等待條件改變。',
  'meihua.relation.tiKeYong.result': '你佔主動，可掌控節奏——按自己的意願推進。',
  'meihua.relation.tiKeYong.jiehua': '保持積極但不強勢——以柔克剛，事半功倍。',
  'meihua.score.title': '整體總結',
  'meihua.score.overall': '整體運勢',
  'meihua.score.auspiciousDir': '吉利方位',
  'meihua.score.auspiciousTime': '吉利時辰',
  'meihua.score.yingQi': '應期',
  'meihua.overallDesc.high': '體用相生——整體運勢順暢，主動出擊，貴人相助，諸事可成。',
  'meihua.overallDesc.mid': '體用平衡——穩步推進，循序漸進，把握當前機遇。',
  'meihua.overallDesc.low': '體用受阻——冷靜觀望，調整方向，等待條件成熟再化解。',
  'meihua.bagua.title': '八卦參考表',
  'meihua.bagua.desc': '八卦由三爻組成，代表八種基本自然現象。在梅花易數中，亦對應五行、方位、家庭成員、身體部位等，用於類比解讀。',

  // ── QimenTab ──────────────────────────────────────────────────
  'qimen.intro.title': '新手必讀：奇門遁甲是什麼？',
  'qimen.intro.history.title': '奇門遁甲的歷史',
  'qimen.intro.history.desc': '奇門遁甲為中國三式（奇門、太乙、六壬）之一，相傳由黃帝所創，諸葛亮、劉伯溫等名人均有應用。以九宮、八門、九星、八神疊加，預測最佳時機與方位。',
  'qimen.intro.jiugong.label': '九宮',
  'qimen.intro.jiugong.desc': '空間分為九個方位（坎北、離南、震東、兌西等），各有固定五行屬性，代表不同能量場。',
  'qimen.intro.bamen.label': '八門',
  'qimen.intro.bamen.desc': '生門、休門、開門最吉；景門次之；死門、驚門、傷門凶；杜門中性。出行與謀劃應取吉門方位。',
  'qimen.intro.jiuxing.label': '九星',
  'qimen.intro.jiuxing.desc': '天輔（文學）、天任（穩定）、天心（醫療）、天蓬（謀略）等九星各為宮位增添不同屬性，賦予特殊性質。',
  'qimen.intro.bashen.label': '八神',
  'qimen.intro.bashen.desc': '值符（貴人）、太陰（暗助）、六合（合作）、九天（高遠）吉；騰蛇（虛驚）、白虎（危險）、玄武（欺詐）凶。',
  'qimen.intro.zhifuzhishi.label': '值符與值使',
  'qimen.intro.zhifuzhishi.desc': '值符是當前主宰天將（貴人方位），值使是當前主宰門（關鍵行動門）。謀事時順應值符與值使所指方向，可事半功倍。',
  'qimen.jiugong.title': '九宮格局',
  'qimen.jiugong.clickHint': '點擊宮位查看詳情',
  'qimen.star.label': '九星',
  'qimen.gate.label': '八門',
  'qimen.god.label': '八神',
  'qimen.zhifu.title': '值符',
  'qimen.zhifu.desc': '主宰貴人之宮，利謀劃順事——朝此方位出行可得天時之利。',
  'qimen.zhishi.title': '值使',
  'qimen.zhishi.desc': '當前行動之門，把握此門性質，可順勢而為。',
  'qimen.auspicious.label': '吉利方位',
  'qimen.inauspicious.label': '忌諱方位',
  'qimen.sanqi.title': '三奇六儀詳解',
  'qimen.sanqi.desc': '奇門天盤由十天干組成：三奇（乙·丙·丁）代表特殊吉祥符號；六儀（戊·己·庚·辛·壬·癸）代表六種能量場。天盤旋轉疊加地盤形成奇門格局。',
  'qimen.sanqi.yi.label': '乙奇',
  'qimen.sanqi.yi.desc': '日奇——極利貴人、文書。柔和化解，能轉凶為吉。',
  'qimen.sanqi.bing.label': '丙奇',
  'qimen.sanqi.bing.desc': '月奇——主武功光輝，攻伐有力，陽剛之氣旺盛。',
  'qimen.sanqi.ding.label': '丁奇',
  'qimen.sanqi.ding.desc': '星奇——神靈護佑，文星旺盛，利考試、讀書、秘密謀劃。',
  'qimen.sanqi.wu.label': '戊儀',
  'qimen.sanqi.wu.desc': '六儀之首——雄厚有力，遇官非困難時有化解之力。',
  'qimen.sanqi.ji.label': '己儀',
  'qimen.sanqi.ji.desc': '主障礙延誤，己在宮時需耐心等候，勿急於進取。',
  'qimen.sanqi.geng.label': '庚儀',
  'qimen.sanqi.geng.desc': '主白虎衝擊，與凶星同宮時防衝突，宜守勿攻。',
  'qimen.score.title': '綜合評估',
  'qimen.jiehua.label': '優化參考',
  'qimen.overallDesc.high': '今日奇門格局大吉，值符當位，三奇齊備——謀劃諸事均得天時之利。',
  'qimen.overallDesc.mid': '今日奇門格局平穩，吉凶混雜——趨吉方位，穩步推進。',
  'qimen.overallDesc.low': '今日奇門格局偏弱，值符受阻——低調靜守，延緩重大決策，等待時機轉化。',
  'qimen.star.tianpeng.meaning': '謀略星——主暗謀機密，防小人。',
  'qimen.star.tianrui.meaning': '疾病星——主病痛阻礙，注重健康調養。',
  'qimen.star.tianchong.meaning': '衝擊星——主衝勁開拓，利雄心進取。',
  'qimen.star.tianfu.meaning': '文書星——主文書學業，利考試進修。',
  'qimen.star.tianqin.meaning': '中央統籌星——主穩定全局。',
  'qimen.star.tianxin.meaning': '醫療星——主康復修補，利身體康復養護。',
  'qimen.star.tianzhu.meaning': '破壞星——主變化衝突，避免正面交鋒。',
  'qimen.star.tianren.meaning': '穩定星——主穩重負責，利長遠規劃。',
  'qimen.star.tianying.meaning': '光輝星——主名聲展示，利社交拓展。',
  'qimen.gate.xiu.meaning': '休養蓄力，利休養、休閒旅遊、水相關事務。',
  'qimen.gate.sheng.meaning': '生機勃勃——大利財運、商業、婚嫁事務。',
  'qimen.gate.shang.meaning': '破壞之門——不利出行，防意外糾紛。',
  'qimen.gate.du.meaning': '隱藏之門——適合保密、蟄伏蓄勢待發。',
  'qimen.gate.jing.meaning': '火門——利文書名聲與宣傳曝光。',
  'qimen.gate.si.meaning': '死門——不利財運出行，靜守可化解。',
  'qimen.gate.jing2.meaning': '驚門——防流言蜚語，低調行事。',
  'qimen.gate.kai.meaning': '開門——大利貴人、求職、重大謀劃。',
  'qimen.god.zhifu.meaning': '值符臨位——主宰貴人，諸事順暢。',
  'qimen.god.tengshe.meaning': '騰蛇主虛驚——防文書誤解。',
  'qimen.god.taiyin.meaning': '太陰主暗助——利秘密謀劃與女性/文書事務。',
  'qimen.god.liuhe.meaning': '六合主合作——利婚嫁、社交、談判。',
  'qimen.god.baihu.meaning': '白虎主危險——防衝突，求安全。',
  'qimen.god.xuanwu.meaning': '玄武主欺詐——防盜竊詐騙。',
  'qimen.god.jiudi.meaning': '九地主穩定——利房地產、穩固防守。',
  'qimen.god.jiutian.meaning': '九天主高遠——利升職、名譽與出行。',

  // ── DaLiurenTab ───────────────────────────────────────────────
  'liuren.intro.title': '新手必讀：大六壬是什麼？',
  'liuren.intro.status.title': '大六壬的地位',
  'liuren.intro.status.desc': '大六壬與奇門遁甲、太乙神數並列「三式」，是中國最古老的占卜體系之一。以十二地支及「月將」為樞紐，旋轉天地盤，得出四課三傳，精準預測事件走向。',
  'liuren.intro.yuejian.label': '月將',
  'liuren.intro.yuejian.desc': '太陽每月進入一個地支，稱為月將。月將是大六壬的起點，加上占卜時辰，天地盤隨之旋轉。',
  'liuren.intro.sike.label': '四課',
  'liuren.intro.sike.desc': '由日干、日支各取兩課，共四課。干上神反映自身，支上神反映外部因素與結果。四課是推導三傳的數據基礎。',
  'liuren.intro.sanchuan.label': '三傳',
  'liuren.intro.sanchuan.desc': '初傳（起始/緣起）→中傳（轉折/關鍵）→末傳（結果/方向）。三傳敘述事件的完整過程，是大六壬斷卦的核心。',
  'liuren.intro.jiang.label': '十二天將',
  'liuren.intro.jiang.desc': '貴人、青龍、六合等十二將分佈於十二宮，賦予各支宮特定的事件屬性與吉凶性質——解讀三傳的關鍵工具。',
  'liuren.sanchuan.title': '三傳・事件解析',
  'liuren.sike.title': '四課詳解',
  'liuren.sike.desc': '四課是三傳的源頭基礎：干上神（第1-2課）反映自身，支上神（第3-4課）反映對方與外部環境。各課之間的生剋關係決定採用何種起傳方式。',
  'liuren.jiang.title': '十二天將詳解',
  'liuren.jiang.desc': '十二將由月將加時辰地支依次排列。貴人、青龍、太常為最吉三將；白虎、玄武、騰蛇需格外注意。三傳遇到哪位天將，即代表人生中受影響最深的領域。',
  'liuren.score.title': '綜合斷語',
  'liuren.jiehua.label': '優化參考',
  'liuren.love.label': '感情',
  'liuren.career.label': '事業',
  'liuren.wealth.label': '財運',
  'liuren.overallDesc.high': '三傳遇吉將，貴人引路——諸事順暢，積極作為必有所成。',
  'liuren.overallDesc.mid': '三傳吉凶混雜，穩步推進——遇阻時靈活應變。',
  'liuren.overallDesc.low': '三傳遇阻將，暫且放緩，調整方向，耐心等待良機。',
  'liuren.loveDesc.auspicious': '末傳吉將臨位，利感情——緣分到來，用心投入。',
  'liuren.loveDesc.normal': '感情略有阻礙——保持真誠溫柔，自然開朗。',
  'liuren.careerDesc.noble': '中傳現貴人或青龍——貴人扶持事業晉升，把握機遇。',
  'liuren.careerDesc.normal': '事業穩步推進——勿急躁，積累沉澱，自有收穫。',
  'liuren.wealthDesc.auspicious': '初傳財星旺——財運暢通，近有進財機遇。',
  'liuren.wealthDesc.normal': '財運平穩——量入為出，逐步積累，避免投機。',
  'liuren.jiang.guiren.meaning': '貴人出現——事情順暢，逢凶化吉。',
  'liuren.jiang.tengshe.meaning': '虛驚——防文書糾紛，謹慎處理合同。',
  'liuren.jiang.zhuque.meaning': '文書口才——利考試申請，宣傳推廣。',
  'liuren.jiang.liuhe.meaning': '合作順暢——感情緣分，合約談判利。',
  'liuren.jiang.gouxian.meaning': '延誤阻礙——房地產訴訟，需耐心化解。',
  'liuren.jiang.qinglong.meaning': '財運順暢，喜慶晉升——吉事臨門，積極進取。',
  'liuren.jiang.tiankong.meaning': '空洞承諾——防虛偽，實際或不符預期。',
  'liuren.jiang.baihu.meaning': '衝突風險——注意防護，求安穩。',
  'liuren.jiang.taichang.meaning': '宴會喜慶——生活安穩舒適，衣食無憂。',
  'liuren.jiang.xuanwu.meaning': '盜竊欺詐——防財物損失，小人在背後搞鬼。',
  'liuren.jiang.taiyin.meaning': '暗中扶持，女性貴人——文書暗助，秘密謀劃有利。',
  'liuren.jiang.tianhou.meaning': '溫柔貴氣——女性事務大吉，感情家庭和諧。',
  'liuren.ke.desc.0': '干上神——反映自身狀態。',
  'liuren.ke.desc.1': '干上神深層——事情的隱藏本質。',
  'liuren.ke.desc.2': '支上神——反映對方狀況。',
  'liuren.ke.desc.3': '支上神深層——事情結果。',
  'liuren.jiehua.0': '順應初傳天將性質——把握所指方向，逐步行動。',
  'liuren.keShiTypes.0': '元首法',
  'liuren.keShiTypes.1': '重審法',
  'liuren.keShiTypes.2': '伏吟法',
  'liuren.keShiTypes.3': '返吟法',
  'liuren.keShiTypes.4': '知一法',
  'liuren.keShiTypes.5': '涉害法',
  'liuren.keShiTypes.6': '遙剋法',
  'liuren.keShiTypes.7': '昂星法',

  // ── TaiyiTab ──────────────────────────────────────────────────
  'taiyi.intro.title': '新手必讀：太乙神數是什麼？',
  'taiyi.intro.intro.title': '三式之首・太乙神數',
  'taiyi.intro.intro.desc': '太乙為三式（太乙、奇門、六壬）之首，用於預測國運、年度趨勢及個人年命。從黃帝元年（公元前2696年）起算，推算當前太乙星以預測年度整體格局。',
  'taiyi.intro.jinian.label': '積年推算',
  'taiyi.intro.jinian.desc': '從黃帝元年到現在的年數為積年（紀年），積年÷16的餘數對應16位太乙神之一（當值主星）；積年÷8確定八宮（當值宮位方向）。',
  'taiyi.intro.16shen.label': '十六太乙神',
  'taiyi.intro.16shen.desc': '16位太乙神輪流當值。吉星（太乙、天乙、青龍等）帶來順暢；凶星（天都、暴布等）需注意相應領域。但凶非必凶——只需多加關注。',
  'taiyi.intro.siji.label': '四積指標',
  'taiyi.intro.siji.desc': '天目主貴人運，地府主財產，人際主關係，鬼算主隱患。四積由年支依次推導，可詳解不同人生領域。',
  'taiyi.intro.jiyue.label': '吉月選擇',
  'taiyi.intro.jiyue.desc': '根據年支與太乙星的五行關係，推算最宜積極行動的月份及宜謹慎保守的月份——有助於規劃全年時間線。',
  'taiyi.star.title': '太乙當值星・年度格局',
  'taiyi.star.monthOverview': '全年月份運勢總覽',
  'taiyi.star.auspicious': '積極謀劃',
  'taiyi.star.cautious': '謹慎調整',
  'taiyi.indicators.title': '天目・地府・人際詳解',
  'taiyi.indicators.desc': '太乙四積是細化年度格局的工具。從年支起，依次推導四個地支，分別為天目（貴人）、地府（財富）、人際（關係）、鬼算（隱患）——各司其職，掌管不同人生領域的能量流動。',
  'taiyi.indicators.tianmu.desc': '今年貴人方位在{{dir}}方。向該方向尋求幫助可得貴人扶持，最宜拜訪導師、拓展人脈、尋求機遇。',
  'taiyi.indicators.difu.desc': '財產在{{dir}}方。今年房地產、理財、創業宜注重此地支方向——與房產相關事務尤為有利。',
  'taiyi.indicators.renji.desc': '人際在{{dir}}方。今年拓展人脈與合作事宜宜主動出擊——團隊合作可帶來意外佳績。',
  'taiyi.indicators.taiyishu.desc': '太乙大數{{num}}——第{{cycle}}個72年大循環中，個人命運正處於週期演化階段。',
  'taiyi.indicators.tianmu': '天目——貴人方向',
  'taiyi.indicators.difu': '地府——財產',
  'taiyi.indicators.renji': '人際——關係',
  'taiyi.indicators.taiyishu': '太乙數',
  'taiyi.16stars.title': '十六太乙神全覽',
  'taiyi.score.title': '年度格局・綜合評分',
  'taiyi.score.personal': '個人年命運勢',
  'taiyi.score.national': '整體趨勢',
  'taiyi.score.currentCycle': '當前所處大勢：{{star}}主歲 · {{year}}年',
  'taiyi.jiehua.label': '優化參考',
  'taiyi.star.tianyi.meaning': '主貴人運，所遇貴人正義仁善——廣結善緣可成大事。',
  'taiyi.star.sheti.meaning': '主變動挫折，避免冒進——變動後耐心等待機遇。',
  'taiyi.star.xuanyuan.meaning': '主穩定實質，事業根基穩固，關係和諧——穩步推進。',
  'taiyi.star.zhaoyao.meaning': '主廣博，貴人與麻煩同來——仔細甄別篩選。',
  'taiyi.star.tianfu.meaning': '主政策變動，國家事務轉移——順應大勢，以穩應變。',
  'taiyi.star.qinglong.meaning': '主財運旺盛，喜事臨門，事業晉升——積極行動，吉祥如意。',
  'taiyi.star.xianchi.meaning': '主感情活躍但情感複雜，以冷靜頭腦處理感情。',
  'taiyi.star.taiyin.meaning': '主暗中扶持，貴人在背後相助——低調行事效果更佳。',
  'taiyi.star.tianyi.meaning2': '主大貴人週期，逢凶化吉——積德行善。',
  'taiyi.star.diyi.meaning': '主地利人和，房地產有利，家庭和諧——根基穩固。',
  'taiyi.star.chengchi.meaning': '主隱性財耗，防損失欺詐——加強財務管理。',
  'taiyi.star.tiancao.meaning': '主官方文書與法律事務，對官員有利——普通人宜低調。',
  'taiyi.star.dicao.meaning': '主土地糾紛，謹慎處理房產合同——避免訴訟。',
  'taiyi.star.tiandu.meaning': '主疾病災厄，注重健康——避免過度疲勞與危險。',
  'taiyi.star.didu.meaning': '主地煞，出行謹慎——佩戴平安卡。',
  'taiyi.star.baobu.meaning': '主突變，備好應急計劃——意外事件保持冷靜。',
  'taiyi.geju.fuyin.name': '太乙伏吟',
  'taiyi.geju.fuyin.desc': '年運積蓄中——表面平靜，潛龍在淵，蓄積資源，避免草率行動。',
  'taiyi.geju.fanyin.name': '太乙返吟',
  'taiyi.geju.fanyin.desc': '運勢波動起伏，保持平常心——靈活應變最為重要。',
  'taiyi.geju.tianyi.name': '天乙貴人',
  'taiyi.geju.tianyi.desc': '貴人運大旺，所遇皆正義仁善——廣結善緣成大事。',
  'taiyi.geju.qinglong.name': '青龍入財',
  'taiyi.geju.qinglong.desc': '財星入局，財運旺盛——積極求財，商業投資或有收穫。',
  'taiyi.geju.taiyin.name': '太陰暗助',
  'taiyi.geju.taiyin.desc': '貴人靜靜相助——突破悄然發生，低調行事效果更佳。',
  'taiyi.geju.xianchi.name': '咸池桃花',
  'taiyi.geju.xianchi.desc': '感情緣分活躍，以理性分辨真愛與遊戲。',
  'taiyi.geju.tiandu.name': '天都犯歲',
  'taiyi.geju.tiandu.desc': '多注重身體——保持健康，避免過勞，定期體檢。',
  'taiyi.geju.baobu.name': '暴布犯歲',
  'taiyi.geju.baobu.desc': '多變多挫，備好應急計劃——冷靜應對，靈活調整。',

  // ── JinkojueTab ───────────────────────────────────────────────
  'jinkojue.intro.title': '新手必讀：金口訣是什麼？',
  'jinkojue.intro.simplified.title': '大六壬的簡化版',
  'jinkojue.intro.simplified.desc': '金口訣是大六壬的簡化實用版，民間流傳最廣。去繁就簡，僅以日干、占時地支和三合六合關係，快速推導三傳與天將，直接明確地斷卦。',
  'jinkojue.intro.step1.step': '① 定時起課',
  'jinkojue.intro.step1.desc': '日干確定天盤起點，占時地支確定地盤位置——兩盤疊合形成基本格局。',
  'jinkojue.intro.step2.step': '② 推導三傳',
  'jinkojue.intro.step2.desc': '以占時地支為初傳，再按三合順序（如寅午戌）推導中傳、末傳——揭示事情的起始、經過與結局。',
  'jinkojue.intro.step3.step': '③ 安置十二將',
  'jinkojue.intro.step3.desc': '將貴人、騰蛇、朱雀等十二天將按地支順序分佈十二宮，各傳各得一將，判定其吉凶性質。',
  'jinkojue.intro.step4.step': '④ 綜合斷語',
  'jinkojue.intro.step4.desc': '審查三傳天將性質（大吉/吉/凶），兼顧旬空，綜合事件方向與應期。',
  'jinkojue.xunkong.title': '何謂旬空？',
  'jinkojue.xunkong.desc': '六十甲子分六旬，每旬十天，每旬末尾兩支「落空」，稱旬空。若三傳有支落旬空，該傳力量減弱——事情可能不實或效果打折。',
  'jinkojue.sanchuan.title': '三傳・起承轉合',
  'jinkojue.score.title': '綜合評估',
  'jinkojue.yingqi.label': '應期',
  'jinkojue.xunkong.label': '旬空',
  'jinkojue.void': '空',
  'jinkojue.events.title': '分類詳解',
  'jinkojue.events.desc': '金口訣按各傳所主領域分維度解讀，初傳顯緣起，中傳顯關鍵轉折，末傳顯最終方向。',
  'jinkojue.duanyu.title': '綜合斷語',
  'jinkojue.jiehua.label': '優化參考',
  'jinkojue.overallDesc.high': '三傳遇吉將——事可成，貴人到來，積極行動有佳績。',
  'jinkojue.overallDesc.mid': '三傳吉凶混雜——遇阻時調整方向，靈活應變，事情最終順暢。',
  'jinkojue.overallDesc.low': '三傳受阻——宜守勿進，耐心等待時機，謀定而後動。',
  'jinkojue.events.guiren.love': '貴人帶來感情機遇——時機成熟，宜告白或求婚。',
  'jinkojue.events.guiren.career': '貴人事業晉升——職場有晉升機遇，積極爭取必成。',
  'jinkojue.events.guiren.wealth': '財運暢通——意外橫財或貴人引薦帶來收入。',
  'jinkojue.events.guiren.health': '身體好轉——即使有小病也能遇良醫化解。',
  'jinkojue.events.qinglong.love': '感情順暢——雙方互相吸引，緣分自然推進。',
  'jinkojue.events.qinglong.career': '事業騰飛——正是進取的時刻，收穫豐碩。',
  'jinkojue.events.qinglong.wealth': '財運大旺——積極進取，回報豐厚。',
  'jinkojue.events.qinglong.health': '精力充沛——身體狀態絕佳。',
  'jinkojue.events.tengshe.love': '感情有誤解——多溝通化解，勿信謠言。',
  'jinkojue.events.tengshe.career': '職場有糾紛——謹慎行事，無需過分擔憂。',
  'jinkojue.events.tengshe.wealth': '防虛假承諾——仔細閱讀財務合同。',
  'jinkojue.events.tengshe.health': '心神略感焦慮——放鬆，保持平靜狀態。',
  'jinkojue.events.zhuque.love': '書面表達感情吉祥——信件或消息告白效果佳。',
  'jinkojue.events.zhuque.career': '文書考試有利——口頭表達帶來機遇。',
  'jinkojue.events.zhuque.wealth': '知識變現——文創收入良好。',
  'jinkojue.events.zhuque.health': '保持心肺健康——少說多休息。',
  'jinkojue.events.liuhe.love': '感情緣分深厚——婚嫁與感情合作均有利。',
  'jinkojue.events.liuhe.career': '合作項目順暢——合約談判吉祥。',
  'jinkojue.events.liuhe.wealth': '合夥生意獲利——共同投資有正回報。',
  'jinkojue.events.liuhe.health': '整體和諧穩定——保持規律作息。',
  'jinkojue.events.baihu.love': '感情有糾紛——保持冷靜，勿升級衝突，時間自然化解。',
  'jinkojue.events.baihu.career': '競爭激烈——沉著冷靜，謹慎應對。',
  'jinkojue.events.baihu.wealth': '防財物損失——大額投資需謹慎評估。',
  'jinkojue.events.baihu.health': '安全第一——避免危險活動，定期體檢。',
  'jinkojue.events.gouxian.love': '感情有延誤——耐心等待，給關係更多時間。',
  'jinkojue.events.gouxian.career': '事業事務延誤——耐心積累，終有所成。',
  'jinkojue.events.gouxian.wealth': '收入延遲——持續努力，自然到來。',
  'jinkojue.events.gouxian.health': '康復需要時間——靜養療愈，勿急躁。',
  'jinkojue.events.tiankong.love': '感情防空洞承諾——核實對方誠意。',
  'jinkojue.events.tiankong.career': '防職場虛位——仔細核查機會。',
  'jinkojue.events.tiankong.wealth': '防空洞投資——仔細審查財務計劃。',
  'jinkojue.events.tiankong.health': '症狀或不反映實際——尋求專業診斷。',
  'jinkojue.events.taiyin.love': '感情暗中有助——女性貴人或可相助。',
  'jinkojue.events.taiyin.career': '幕後靜靜相助——低調行事效果更佳。',
  'jinkojue.events.taiyin.wealth': '隱性收入來源——幕後意外回報。',
  'jinkojue.events.taiyin.health': '身體靜靜康復——保持穩定日常習慣。',
  'jinkojue.events.tianhou.love': '女性事務大吉——感情緣分與家庭和諧均有利。',
  'jinkojue.events.tianhou.career': '溫柔穩健推進事業——與女同事合作和諧。',
  'jinkojue.events.tianhou.wealth': '財運平穩——長期保守理財有穩定回報。',
  'jinkojue.events.tianhou.health': '身體陰陽平衡——陰氣充足，康復順暢。',
  'jinkojue.events.taichang.love': '生活舒適——宴會喜慶場合或帶來感情機緣。',
  'jinkojue.events.taichang.career': '事業平穩舒適——適合長期穩定崗位。',
  'jinkojue.events.taichang.wealth': '生活費用充足——財富中等偏豐。',
  'jinkojue.events.taichang.health': '食慾精神良好——保持適度飲食與運動。',
  'jinkojue.events.xuanwu.love': '感情事務隱晦——對方或非完全真誠。',
  'jinkojue.events.xuanwu.career': '防職場小人——保持警惕。',
  'jinkojue.events.xuanwu.wealth': '防盜竊詐騙——財務安全重要。',
  'jinkojue.events.xuanwu.health': '隱性症狀——勿忽視輕微不適。',

  // ── 頁面級 & 各tab補充 key ───────────────────────────────────
  'header.solarLabel': '公曆',
  'header.switchProfile': '切換',
  'stats.algorithms': '算法',
  'stats.algorithmsUnit': '種',
  'qimen.banner.title': '奇門遁甲排局',
  'qimen.banner.zhifuPrefix': '值符臨',
  'qimen.palaceSuffix': '宮',
  'qimen.elementSuffix': '屬性',
  'qimen.zhifuSection.title': '值符值使 · 吉凶方位',
  'qimen.star.prefix': '九星：',
  'qimen.gate.prefix': '八門：',
  'qimen.god.prefix': '八神：',
  'liuren.banner.title': '大六壬課式',
  'liuren.banner.yuejianPrefix': '月將',
  'liuren.banner.daySuffix': '日',
  'liuren.jiehuaPrefix': '調和：',
  'liuren.ke.tianLabel': '天：',
  'liuren.ke.diLabel': '地：',
  'taiyi.banner.title': '太乙神數',
  'taiyi.banner.jiNianPrefix': '積年',
  'taiyi.banner.linSuffix': '臨',
  'taiyi.banner.wuxingPrefix': '五行',
  'taiyi.banner.elementSuffix': '屬性',
  'taiyi.banner.palaceIn': '{{palace}}宮',
  'taiyi.starNum.prefix': '第',
  'taiyi.starNum.suffix': '太乙星',
  'taiyi.monthSuffix': '月',
  'taiyi.currentYear': '今年當值',
  'jinkojue.banner.title': '金口訣預測',
  'jinkojue.banner.daySuffix': '日',
  'jinkojue.banner.hourSuffix': '時',
  'jinkojue.banner.xunKongLabel': '旬空:',
  'jinkojue.jiangNaturePrefix': '主',
  'liuren.chuan.first': '初傳',
  'liuren.chuan.middle': '中傳',
  'liuren.chuan.last': '末傳',
  'score.pts': '分',
  'meihua.relation.same.name': '比和',
  'meihua.relation.yongShengTi.name': '用生體',
  'meihua.relation.tiShengYong.name': '體生用',
  'meihua.relation.yongKeTi.name': '用剋體',
  'meihua.relation.tiKeYong.name': '體剋用',
  'meihua.card.original': '本卦',
  'meihua.card.inner': '互卦',
  'meihua.card.changed': '變卦',
  'meihua.card.cuo': '錯卦',
  'meihua.card.zong': '綜卦',
  'meihua.card.desc.original': '現在狀況',
  'meihua.card.desc.inner': '隱藏本質',
  'meihua.card.desc.changed': '最終方向',
  'meihua.card.desc.cuo': '對立面',
  'meihua.card.desc.zong': '反向視角',
  'meihua.movingLine': '動爻：第{{num}}爻',
  'meihua.summary.high': '三卦吉象一致，用生體，貴人運強，諸事可成。',
  'meihua.summary.mid': '卦象示穩步推進，謹慎觀察把握當前機遇。',
  'meihua.summary.low': '卦象示謹慎，調整方向，等待條件成熟再行動。',
  'qimen.juDesc.yang': '陽遁{{num}}局，陽氣上升',
  'qimen.juDesc.yin': '陰遁{{num}}局，陰氣深化',
  'qimen.jiehua.text': '優先{{auspDir}}方向，避開{{inauspDir}}——順勢而為，障礙自然化解。',
  'qimen.summary.high': '值符當位，吉門大開——諸事謀劃均得天時之利。',
  'qimen.summary.mid': '吉凶混雜，趨吉門方向穩步推進。',
  'qimen.summary.low': '值符受阻——低調靜守，延緩重大決策，待時機轉化。',
  'taiyi.elementBadge': '{{el}}屬性',
  'taiyi.inPalace': '{{palace}} · {{dir}}方',
  'taiyi.jiehua.needsAttention': '今年太乙星需格外留意。',
  'taiyi.jiehua.text': '順應{{palace}}的{{nature}}能量——把握吉月（{{months}}）化解障礙。',
  'taiyi.overallDesc.high': '{{star}}主值今年，運勢大旺。大膽前進，貴人相助，萬事可成。',
  'taiyi.overallDesc.mid': '{{star}}主值今年，能量均衡。穩中有機，靜觀待時，把握時機。',
  'taiyi.overallDesc.low': '{{star}}主值今年，需謹慎應對。穩健守成，耐心調整，終將改善。',
  'taiyi.indicators.tianmu.meaning': '貴人方向',
  'taiyi.indicators.difu.meaning': '財產田宅',
  'taiyi.indicators.renji.meaning': '人際關係',
  'taiyi.indicators.taiyishu.meaning': '大週期數',
  'jinkojue.jiehua.text': '順應初傳{{general}}能量——{{meaning}} — 循此方向化解阻礙。',
  'jinkojue.jiehua.high': '三傳吉將齊聚，自信行動，貴人引路，必有所成。',
  'jinkojue.jiehua.mid': '傳象混雜，遇阻調整方向，靈活應變，事必順暢。',
  'jinkojue.jiehua.low': '守勝於攻，耐心謀定，靜待時機，自然化解。',
  'liuren.jiehua.貴人': '貴人能量活躍，把握貴人緣，積極出擊，事必順暢。',
  'liuren.jiehua.螣蛇': '慎防誤解，仔細核實信息，耐心等待可化解複雜局面。',
  'liuren.jiehua.朱雀': '以文書或口才推進——文書與溝通是當下的有力工具。',
  'liuren.jiehua.六合': '合作為要，協議、合夥、談判均可順利推進。',
  'liuren.jiehua.勾陳': '遇延誤需耐心，穩步積累終將突破。',
  'liuren.jiehua.青龍': '運勢正旺，此刻出擊，財運與事業雙線上揚。',
  'liuren.jiehua.天空': '行動前先核實，防空洞承諾，確認事實再承諾。',
  'liuren.jiehua.白虎': '安全第一，避免衝突，防意外及財物損失。',
  'liuren.jiehua.太常': '安穩平和，維持日常，宴席場合或帶來意外機緣。',
  'liuren.jiehua.玄武': '保持警覺，防欺詐暗算，信任前務必核查。',
  'liuren.jiehua.太陰': '靜靜幕後出力，謹慎謀劃，低調行事效果更佳。',
  'liuren.jiehua.天后': '柔和和諧能量，女性事務、家庭與合作均吉。',
  'jinkojue.xunkongDetail.title': '旬空詳解',
  'jinkojue.xunkongDetail.tag': '影響與調和',
  'jinkojue.xunkongDetail.desc': '旬空是六十甲子中每旬末尾兩支「落空」的現象。旬空地支的力量暫時缺失，若三傳中有旬空地支，該傳所代表的事項可能「不實」或「打折」，需特別注意。',
  'jinkojue.xunkongDetail.voidBranches': '旬空地支',
  'jinkojue.xunkongDetail.voidHint': '力量暫時缺失',
  'jinkojue.xunkongDetail.activeBranches': '活躍地支',
  'jinkojue.xunkongDetail.activeHint': '力量充沛可用',
  'jinkojue.xunkongDetail.impactTitle': '旬空對三傳的影響',
  'jinkojue.xunkongDetail.voidLabel': '旬空',
  'jinkojue.xunkongDetail.activeLabel': '有力',
  'jinkojue.xunkongDetail.zhiLabel': '地支：',
  'jinkojue.xunkongDetail.impactVoid': '{{chuan}}（{{jiang}}）的地支{{zhi}}（{{wx}}）落入旬空——該傳力量暫時缺失，所問之事可能不實、效果打折或延遲應驗。',
  'jinkojue.xunkongDetail.impactActive': '{{chuan}}（{{jiang}}）的地支{{zhi}}（{{wx}}）不在旬空——該傳力量正常發揮，所問之事有據可依。',
  'jinkojue.xunkongDetail.voidAdviceLabel': '旬空應對建議',
  'jinkojue.xunkongDetail.voidAdvice': '{{jiang}}（{{chuan}}）雖遇旬空，但並非毫無希望——可等旬空出空（約10天後）再行動，或借助其他有力之傳推進。',
  'jinkojue.xunkongDetail.resolveTitle': '旬空調和四法',
  'jinkojue.xunkongDetail.resolve.timing': '等旬空出空：旬空一般10天後自然「出空」，屆時力量恢復，可重新行動。',
  'jinkojue.xunkongDetail.resolve.direction': '借旺方之力：向當月旺相地支所在方位尋求幫助，以旺氣補空缺。',
  'jinkojue.xunkongDetail.resolve.helper': '求貴人相助：若所問之事涉及人，找非旬空地支日出生的朋友或長輩協助。',
  'jinkojue.xunkongDetail.resolve.retry': '反覆確認：旬空之事宜反覆核查，不要僅憑一次結果做重大決定。',
  'jinkojue.xunkongDetail.fullGridTitle': '十二地支旬空狀態總覽',
  'jinkojue.xunkongDetail.voidShort': '旬空',
  'jinkojue.xunkongDetail.activeShort': '有力',

  'taiyi.yearlyChart.title': '年度運勢走勢圖',
  'taiyi.yearlyChart.tag': '12個月走勢',
  'taiyi.yearlyChart.desc': '{{star}}主值{{year}}年，綜合吉月、五行生克與主星屬性，推算全年12個月運勢起伏。',
  'taiyi.yearlyChart.avg': '年均',
  'taiyi.yearlyChart.peak': '運勢高峰',
  'taiyi.yearlyChart.peakDesc': '{{month}}月運勢最高（{{score}}分），{{wx}}氣當令——宜積極行動。',
  'taiyi.yearlyChart.valley': '運勢低谷',
  'taiyi.yearlyChart.valleyDesc': '{{month}}月運勢較低（{{score}}分），{{wx}}氣當令——宜守不宜攻。',
  'taiyi.yearlyChart.quarterAdvice': '季度建議',
  'taiyi.yearlyChart.q1': 'Q1',
  'taiyi.yearlyChart.q2': 'Q2',
  'taiyi.yearlyChart.q3': 'Q3',
  'taiyi.yearlyChart.q4': 'Q4',
  'taiyi.yearlyChart.quarterText': '全年來看，{{bestQuarter}}運勢最佳（{{bestScore}}分），{{worstQuarter}}需注意（{{worstScore}}分）。順應{{star}}的能量節奏，在高峰月積極行動、低谷月保守蓄力，可最大化年度運勢收益。',
  'taiyi.yearlyChart.now': '本月',
  'boundaryReminder.title': '邊界提醒',
  'boundaryReminder.content': '周易占卜以卦象映射當下情境，揭示的是趨勢與規律，而非不可更改的宿命。占卜的價值在於啟發，而非替代你的判斷。',
};

export default zhouyiDetail;
